/* NYGHT offer packs (2026-10-02): the PDP "Vælg din pakke" block. Pack 1 adds the duvet + the free pillow, pack 2
   adds two duvets (each with its own weight) + two pillows. Prices come from automatic discounts in Shopify; this only
   decides what goes in the cart. Catches every add-to-cart form for this product (main button and sticky bar). */
(() => {
  const root = document.querySelector('[data-nn-offer]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  // strings + money follow the storefront language/currency (snippets/nyght-i18n, 2026-10-24); Danish fallbacks
  const T = (k, d) => (window.NyghtT ? window.NyghtT(k, d) : d);
  const spar = (c) => T('offer_save', 'Spar') + ' ' + money(c);
  // the gift and the pack prices end with the automatic discounts — after that the page is a normal product page
  if (root.dataset.ends && Date.now() >= Date.parse(root.dataset.ends)) { root.hidden = true; return; }
  const duvets = new Set(JSON.parse(root.dataset.variants || '[]'));
  const second = root.querySelector('[data-nn-duo-variant]');
  let secondTouched = false;
  const pack = () => +(root.querySelector('input[type=radio]:checked')?.value || 1);
  const labels = () => document.querySelectorAll('.nn-buy__btn > span:first-child, nn-sticky-atc [type=submit] > span:first-child');
  const sync = () => {
    root.querySelectorAll('.nn-pack').forEach((l) => l.classList.toggle('is-on', l.querySelector('input').checked));
    root.classList.toggle('is-duo', pack() >= 2);
    const vt = root.querySelector('.nn-vt__title');
    if (vt) { if (vt.dataset.base === undefined) vt.dataset.base = vt.textContent.trim(); vt.textContent = pack() >= 2 ? T('offer_duvet1_size_weight', 'Dyne 1 · størrelse og vægt') : vt.dataset.base; }
    labels().forEach((s) => {
      if (s.dataset.base === undefined) s.dataset.base = s.textContent.trim();
      s.textContent = pack() === 3 && root.dataset.fullCents ? (root.dataset.duoButton || s.dataset.base) + ' · ' + money(+root.dataset.fullCents) : pack() === 2 ? root.dataset.duoLabel : s.dataset.base;
    });
  };
  root.addEventListener('change', (e) => { if (e.target === second) secondTouched = true; sync(); renderBumps(); });

  // "Tilføj sengetøj" (2026-10-06): optional, never pre-ticked. The bundle's size follows the duvet(s); with two
  // different sizes in Pakken til to the upgrade is off (the two-duvet bundle holds two covers of one size).
  const money = (c) => (window.NyghtFmt ? window.NyghtFmt.money(c) : new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 }).format(Math.round(c / 100)) + ' kr.');
  const giftMap = () => { try { return JSON.parse(root.dataset.giftMap || 'null'); } catch (e) { return null; } };
  // the free cover is worth 395 or 495 kr. depending on the duvet's size: shift the card's "værdi"/"Spar" by the difference
  const giftDelta = (n) => {
    const gm = giftMap(); if (!gm) return 0;
    const base = +root.dataset.giftBase || 0, p = (vid) => ((gm[sizeOf(vid)] || {}).p || base) - base;
    return n >= 2 ? p(mainId()) + p(secondId()) : p(mainId());
  };
  const vlistAll = JSON.parse(root.dataset.vlist || '[]');
  const sizeOf = (vid) => (vlistAll.find((v) => String(v.id) === String(vid)) || { o: [] }).o[0];
  const mainId = () => +(document.querySelector('.nn-buy form [name=id]')?.value || 0);
  const secondId = () => +(secondTouched && second ? second.value : mainId());
  const bumpState = (b) => {
    const n = +b.dataset.nnBump, vars = JSON.parse(b.dataset.vars || '{}'), vals = JSON.parse(b.dataset.values || '{}');
    const s1 = sizeOf(mainId()), s2 = n >= 2 ? sizeOf(secondId()) : s1;
    const bed = b.dataset.bed, key = s1 + '|' + bed;
    const v = s1 && s1 === s2 ? vars[key] : null;
    const anyKey = Object.keys(vars).find((k) => k.endsWith('|' + bed));
    const price = (v && v.p) || (anyKey && vars[anyKey].p) || +b.dataset.price;
    return { n, ok: !!(v && v.a), id: v && v.id, price, value: vals[key] || vals[Object.keys(vals).find((k) => k.endsWith('|' + bed))] || 0, mixed: n >= 2 && s1 && s2 && s1 !== s2 };
  };
  function renderBumps() {
    root.querySelectorAll('[data-nn-bump]').forEach((b) => {
      const st = bumpState(b), price = st.price;
      const pEl = b.querySelector('[data-nn-bump-price]'); if (pEl) pEl.textContent = '+' + money(price);
      // a sheet size that costs more says so on its button (e.g. "Dobbeltseng · +100 kr.")
      const vars0 = JSON.parse(b.dataset.vars || '{}'), lowest = Math.min(...Object.values(vars0).map((x) => x.p || 0).filter(Boolean));
      b.querySelectorAll('[data-nn-bed-hint]').forEach((h) => {
        const k = Object.keys(vars0).find((x) => x.endsWith('|' + h.closest('[data-nn-bed]').dataset.nnBed));
        const extra = k ? vars0[k].p - lowest : 0;
        h.textContent = h.dataset.nnBedHint + (extra > 0 ? ' · +' + money(extra) : '');
      });
      const card0 = b.closest('.nn-pack'), active = !!card0.querySelector('input')?.checked;
      // the upgrade belongs to the chosen card: un-tick it when that card is not chosen or the size combo has no bundle
      if (b.dataset.included) {
        b.querySelector('[data-nn-bump-note]').hidden = !st.mixed;
        b.querySelector('[data-nn-bump-value]').textContent = money(st.value);
        const card3 = b.closest('.nn-pack'), ps3 = card3.querySelector('.nn-pack__save[data-base-value]'), pb3 = card3.querySelector('.nn-pack__price b[data-cents]');
        if (ps3 && pb3) ps3.textContent = spar(+ps3.dataset.baseValue + st.value - +pb3.dataset.cents);
        return;
      }
      if (!st.ok || !active) { b.classList.remove('is-checked'); b.setAttribute('aria-checked', 'false'); }
      b.classList.toggle('is-off', !st.ok); b.setAttribute('aria-disabled', String(!st.ok));
      b.querySelector('[data-nn-bump-note]').hidden = !st.mixed;
      b.querySelector('[data-nn-bump-value]').textContent = money(st.value);
      b.querySelector('[data-nn-bump-save]').textContent = st.value > price ? spar(st.value - price) : '';
      const card = b.closest('.nn-pack'), pb = card.querySelector('.nn-pack__price b[data-cents]'), ps = card.querySelector('.nn-pack__save[data-cents]');
      const on = b.classList.contains('is-checked');
      if (pb) pb.textContent = money(+pb.dataset.cents + (on ? price : 0));
      if (ps) ps.textContent = spar(+ps.dataset.cents + giftDelta(st.n) + (on ? st.value - price : 0));
      if (st.n === 2 && root.dataset.duoButton) root.dataset.duoLabel = root.dataset.duoButton + ' · ' + money(+root.dataset.duoCents + (on ? price : 0));
    });
    // cards without a bedding box (Pakken til to) and the gift lines follow the duvet size too
    const gm = giftMap();
    if (gm) {
      const base = +root.dataset.giftBase || 0;
      root.querySelectorAll('[data-nn-gift-v]').forEach((el) => {
        const n = +el.dataset.nnGiftV, g1 = (gm[sizeOf(mainId())] || {}).p || base, g2 = n >= 2 ? ((gm[sizeOf(secondId())] || {}).p || base) : 0;
        el.textContent = money(g1 + g2);
      });
      root.querySelectorAll('.nn-pack').forEach((c) => {
        if (c.querySelector('[data-nn-bump]:not([data-included])')) return;
        const ps = c.querySelector('.nn-pack__save[data-cents]'), v = +(c.querySelector('input')?.value || 1);
        if (ps) ps.textContent = spar(+ps.dataset.cents + giftDelta(v));
      });
    }
    sync();
    // the price on each card's own button follows the card (incl. a ticked bedding box)
    root.querySelectorAll('.nn-pack').forEach((c) => { const t = c.querySelector('[data-nn-atc-price]'), pb = c.querySelector('.nn-pack__price b'); if (t && pb) t.textContent = pb.textContent; });
  }
  function bumpVariant(n) {
    const b = root.querySelector(`[data-nn-bump="${n}"].is-checked`);
    if (b && b.dataset.included && pack() !== 3) return 0;
    if (!b) return 0;
    const st = bumpState(b);
    return st.ok ? +st.id : 0;
  }
  const toggleBump = (b) => {
    if (b.dataset.included) return;
    if (bumpState(b).ok === false) return;
    const on = !b.classList.contains('is-checked');
    b.classList.toggle('is-checked', on); b.setAttribute('aria-checked', String(on));
    renderBumps();
  };
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nn-bump]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const bed = e.target.closest('[data-nn-bed]');
    if (bed) {   // sheet size for the customer's bed — does not tick the box by itself
      b.dataset.bed = bed.dataset.nnBed;
      b.querySelectorAll('[data-nn-bed]').forEach((x) => x.classList.toggle('is-on', x === bed));
      renderBumps();
      return;
    }
    toggleBump(b);
  }, true);
  root.addEventListener('keydown', (e) => {
    const b = e.target.closest && e.target.closest('[data-nn-bump]');
    if (b && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); toggleBump(b); }
  });
  document.addEventListener('change', () => setTimeout(renderBumps, 0));
  root.addEventListener('click', (e) => {
    const atc = e.target.closest('[data-nn-pack-atc]');
    if (!atc) return;
    e.preventDefault(); e.stopPropagation();
    const card = atc.closest('.nn-pack'), radio = card.querySelector('input[type=radio]');
    if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    const form = document.querySelector('.nn-buy form[action*="/cart/add"]');
    if (!form) return;
    atc.disabled = true;
    const done = () => { atc.disabled = false; root.removeEventListener('nn:added', done); };
    root.addEventListener('nn:added', done);
    setTimeout(done, 8000);
    form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }, true);
  // until the shopper picks a weight for duvet 2, it follows the weight chosen above
  document.addEventListener('change', (e) => {
    if (secondTouched || !second || !e.target.matches('[name=id], .product-variant-id, select, input')) return;
    const id = document.querySelector('.nn-buy form [name=id]')?.value;
    if (id && [...second.options].some((o) => o.value === id)) second.value = id;
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const id = +(form.querySelector('[name=id]')?.value || 0);
    if (!duvets.has(id)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const btn = form.querySelector('[type=submit]');
    if (btn?.classList.contains('loading')) return;
    btn?.classList.add('loading');
    btn?.querySelector('.loading__spinner')?.classList.remove('hidden');
    const duo = pack() >= 2;
    const cardErr = root.querySelector('.nn-pack.is-on [data-nn-card-err]'); if (cardErr) cardErr.hidden = true;
    if (pack() === 3 && !bumpVariant(3)) {
      const msg = T('offer_same_size', 'Vælg samme størrelse på begge dyner – sengetøjet til to følger én størrelse.');
      if (cardErr) { cardErr.textContent = msg; cardErr.hidden = false; }
      root.dispatchEvent(new CustomEvent('nn:added'));
      return;
    }
    const items = [{ id, quantity: 1 }];
    if (duo) {
      const id2 = +(secondTouched && second ? second.value : id);
      if (id2 === id) items[0].quantity = 2; else items.push({ id: id2, quantity: 1 });
    }
    // gift (campaign, 2026-10-11): a size-matched gift (duvet cover) per duvet when the page carries a gift map,
    // otherwise the single gift product (pillow) — none during Black Month.
    const gmap = giftMap();
    if (gmap && pack() !== 3) {   // 'Den komplette seng' already includes covers
      const addGift = (vid) => { const g = gmap[sizeOf(vid)]; if (!g || !g.a) return; const ex = items.find((x) => x.id === g.id); if (ex) ex.quantity += 1; else items.push({ id: g.id, quantity: 1 }); };
      addGift(id);
      if (duo) addGift(+(secondTouched && second ? second.value : id));
    } else if (root.dataset.pillowOk === 'true') items.push({ id: +root.dataset.pillow, quantity: duo ? 2 : 1 });
    const bundle = bumpVariant(pack() === 3 ? 3 : duo ? 2 : 1);
    if (bundle) items.push({ id: bundle, quantity: 1 });
    const errWrap = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || T('offer_add_error', 'Det lykkedes ikke at lægge pakken i kurven.'));
      if (errWrap) errWrap.hidden = true;
      if (window.nyghtCart) window.nyghtCart.refresh(true); else window.location.href = '/cart';
    } catch (err) {
      if (errWrap) { errWrap.hidden = false; errWrap.querySelector('.product-form__error-message').textContent = err.message; }
    } finally {
      root.dispatchEvent(new CustomEvent('nn:added'));
      btn?.classList.remove('loading');
      btn?.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }, true);
  // Split-test switch (2026-10-24, test "cro1"): an arm that sets `:root { --nn-wm: on }` puts a weight finder above the
  // packs. Body weight → 5 / 7 / 9 kg (vægtguide 40–59 / 60–79 / 80+; 11 and 13 kg are sold out), and letting go of
  // the slider presses that weight for Dyne 1. Nothing is pressed until the shopper moves it.
  if (getComputedStyle(document.documentElement).getPropertyValue('--nn-wm').trim() === 'on' && !root.querySelector('.nn-wm')) {
    const wm = document.createElement('div');
    wm.className = 'nn-wm';
    wm.innerHTML = `<style>.nn-wm{margin:0 0 14px;padding:14px 16px 12px;border-radius:16px;background:#f7f2fa;color:#4a225d;font-family:'Gilroy',sans-serif}.nn-wm__h{margin:0 0 4px;font:600 17px/1.25 'Gilroy',sans-serif}.nn-wm__t{margin:0;font:500 15px/1.4 'Gilroy',sans-serif;color:#6d5a77}.nn-wm__t b{color:#4a225d}.nn-wm__r{width:100%;margin:10px 0 0;accent-color:#4a225d}</style>`
      + `<p class="nn-wm__h">${T('wm_title', 'Hvilken vægt passer til dig?')}</p><p class="nn-wm__t" data-nn-wm-t>${T('wm_hint', 'Træk i skyderen, så vælger vi vægten for dig.')}</p>`
      + `<input class="nn-wm__r" type="range" min="40" max="120" value="70" step="1" aria-label="${T('wm_your_weight', 'Din vægt')}">`;
    const firstPack = root.querySelector('.nn-pack');
    (firstPack ? firstPack.parentNode : root).insertBefore(wm, firstPack);
    const range = wm.querySelector('input'), out = wm.querySelector('[data-nn-wm-t]');
    const pick = (press) => {
      const w = +range.value, kg = w < 60 ? 5 : w < 80 ? 7 : 9;
      out.innerHTML = T('wm_result', 'Du vejer [w] kg → vi anbefaler <b>[kg] kg</b>').replace('[w]', w).replace('[kg]', kg);
      if (!press) return;
      const b = [...root.querySelectorAll(`[data-nn-mini="main"] [data-v="${kg}kg"]`)].find((x) => x.offsetParent);
      if (b && !b.classList.contains('is-on')) b.click();
    };
    range.addEventListener('input', () => pick(false));
    range.addEventListener('change', () => pick(true));
  }
  // ?pack=2 (from the Sidste parti landing page) opens with "Pakken til to" chosen. So does a split-test arm that sets
  // the CSS switch `:root { --nn-pack: 2 }` in its console CSS (2026-10-24, test "cro1").
  const packSwitch = getComputedStyle(document.documentElement).getPropertyValue('--nn-pack').trim();
  if (new URLSearchParams(location.search).get('pack') === '2' || packSwitch === '2') {
    const duo = root.querySelector('input[type=radio][value="2"]');
    if (duo) duo.checked = true;
  }
  // Small size/weight buttons inside the pack cards (2026-10-02, owner: "variant pickers as small buttons inside
  // the offer blocks"). "main" rows press the (hidden) variant tiles, so price, stock and the form id stay in sync;
  // the "second" row (Pakken til to, Dyne 2) picks the second duvet.
  const vt = root.querySelector('[data-nn-vt]');
  const vlist = JSON.parse(root.dataset.vlist || '[]');
  // Real stock for the chosen size + weight (2026-10-10, owner: "fix them all" — benchmark item: honest scarcity).
  const STOCK_MAX = 40; // 2026-10-15 owner: "Incorporate næsten udsolgt multiple places" (same threshold as snippets/nyght-low.liquid)
  const eta = document.querySelector('.nn-eta__stock');
  const etaHtml = eta ? eta.innerHTML : '';
  const stockLine = () => {
    if (!vt) return;
    const want = [...vt.querySelectorAll('.nn-vt__group')].map((g) => g.querySelector('.nn-vt__opt.is-on')?.dataset.value);
    const cur = vlist.find((v) => v.o.every((o, i) => want[i] === undefined || o === want[i]));
    root.querySelectorAll('[data-nn-mini="main"]').forEach((row) => {
      let el = row.nextElementSibling;
      if (!el || !el.matches('[data-nn-stock]')) { el = document.createElement('span'); el.className = 'nn-mini__stock'; el.dataset.nnStock = ''; row.after(el); }
      const q = cur ? cur.q : 0;
      el.hidden = !(cur && cur.a && q > 0 && q <= STOCK_MAX);
      el.textContent = el.hidden ? '' : T('offer_almost_sold_out', 'Næsten udsolgt') // 2026-10-15 owner: "dont say what styles, just say almost udsolgt";
    });
    if (eta) {
      const low = !!(cur && cur.a && cur.q > 0 && cur.q <= STOCK_MAX);
      eta.classList.toggle('is-low', low);
      eta.innerHTML = low ? '<i aria-hidden="true"></i>' + T('offer_almost_sold_out', 'Næsten udsolgt') + '.' : etaHtml;
    }
  };
  const syncMain = () => root.querySelectorAll('[data-nn-mini="main"] [data-g]').forEach((b) => {
    const t = vt && vt.querySelector(`.nn-vt__group[data-index="${b.dataset.g}"] .nn-vt__opt[data-value="${CSS.escape(b.dataset.v)}"]`);
    if (!t) return;
    b.classList.toggle('is-on', t.classList.contains('is-on'));
    b.classList.toggle('is-out', t.classList.contains('is-out'));
  });
  const syncSecond = () => {
    const cur = vlist.find((v) => String(v.id) === String(second?.value));
    root.querySelectorAll('[data-nn-mini="second"]').forEach((row) => {
      const btns = [...row.querySelectorAll('[data-g]')];
      btns.forEach((b) => { if (cur) b.classList.toggle('is-on', cur.o[+b.dataset.g] === b.dataset.v); });
      btns.forEach((b) => {
        const want = cur ? cur.o.slice() : [];
        want[+b.dataset.g] = b.dataset.v;
        const hit = vlist.find((v) => v.o.every((o, i) => o === want[i] || want[i] === undefined));
        b.classList.toggle('is-out', !hit || !hit.a);
      });
    });
  };
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nn-mini] [data-g]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const row = b.closest('[data-nn-mini]');
    if (row.dataset.nnMini === 'main') {
      const t = vt && vt.querySelector(`.nn-vt__group[data-index="${b.dataset.g}"] .nn-vt__opt[data-value="${CSS.escape(b.dataset.v)}"]`);
      if (t) t.click();
      setTimeout(() => { syncMain(); syncSecond(); stockLine(); }, 0);
    } else if (second) {
      const cur = vlist.find((v) => String(v.id) === String(second.value)) || vlist[0];
      const want = cur.o.slice(); want[+b.dataset.g] = b.dataset.v;
      let hit = vlist.find((v) => v.a && v.o.every((o, i) => o === want[i]));
      if (!hit) hit = vlist.find((v) => v.a && v.o[+b.dataset.g] === b.dataset.v);   // e.g. size changed to one where that weight is sold out
      if (!hit) return;
      second.value = String(hit.id);
      second.dispatchEvent(new Event('change', { bubbles: true }));
      syncSecond();
    }
  });
  document.addEventListener('change', () => setTimeout(() => { syncMain(); syncSecond(); stockLine(); }, 0));
  if (vt) { syncMain(); syncSecond(); stockLine(); }
  sync();
  renderBumps();
})();
